$(document).ready(function() {
    $(".accordionAnswer").click(function () {
        var elm = $(this);
        if (elm.next(".accordionBoxAnswer").is(":visible")) {
            elm.removeClass("active")
                .next(".accordionBoxAnswer")
                .slideUp(200);
        } else {
            elm.next(".accordionBoxAnswer")
                .slideDown(200)
                .siblings(".accordionBoxAnswer")
                .slideUp(200)
                .siblings(".accordionAnswer")
                .removeClass("active");
            elm.addClass("active");
        }
    });
});
